import axios from "axios";

const URL = process.env.REACT_APP_USER_API;

export async function getReportLogs(payload) {
  let url = URL + "/logs";
  let response = await axios.post(url, payload);
  return response.data;
}

export async function getReportLogsSummary(payload) {
  let url = URL + "/logs/summary";
  let response = await axios.get(url, { params: payload });
  return response.data;
}

export async function getDispatchSummary(payload) {
  let url = URL + "/dispatch/summary";
  let response = await axios.get(url, { params: payload });
  return response.data;
}

export async function getSerialNumberDispatchReport(payload) {
  let url = URL + "/getSerialNumberDispatchReport";
  let response = await axios.post(url, payload);
  return response.data;
}
export async function getBranchUserValidationLogs(payload) {
  let url = URL + "/getBranchUserValidationLogs";
  let response = await axios.post(url, payload);
  return response.data;
}